<template>
  <v-container>
    <h4>Contact Information</h4>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <p>Email:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.email || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Phone number:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.phone_number || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Line ID:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.line_id || '-' }}</p>
      </v-col>
      <v-col
        cols="12"
      >
        <gmap-map
          :center="{lat: lat, lng:lng}"
          :zoom="13"
          map-type-id="terrain"
          class="g-location"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
          }"
        >
          <gmap-marker :position="{lat: mark_lat, lng: mark_lng}" :clickable="false" :draggable="false"></gmap-marker>
        </gmap-map>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Address detail:</p>
      </v-col>
      <v-col
        cols="8"
        md="10"
      >
        <p>{{ contact_information.address_detail || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Sub-district:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.address_sub_district || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>District:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.address_district || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Province/State:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.address_province || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Country:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.address_country || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Postal code/Zipcode:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.address_postal_code || '-' }}</p>
      </v-col>
      <v-col cols="12" md="6">
        <v-spacer></v-spacer>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Emergency contact person:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.emergency_contact_person || '-' }}</p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <p>Emergency contact phone number:</p>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>{{ contact_information.emergency_contact_phone || '-' }}</p>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'ContactInformation',
  components: { },
  props: ['contact_information'],
  data: () => ({
    lat: 13.7563,
    lng: 100.5018,
    mark_lat: null,
    mark_lng: null,
    rules: {
      require: value => !!value || 'Please fill in information',
      email: eml => !eml || /.+@.+\..+/.test(eml) || "E-mail must be valid",
    }
  }),
  mounted () {
    if (this.contact_information.address_glat && this.contact_information.address_glng) {
      this.lat = this.contact_information.address_glat
      this.lng = this.contact_information.address_glng
      this.mark_lat = Number(this.contact_information.address_glat)
      this.mark_lng = Number(this.contact_information.address_glng)
    }
  },
  methods: { }
}
</script>

<style>
.g-location {
  height: 350px;
  width: auto;
  max-width: 860px;
}
@media (max-width: 767px) {
  .g-location {
    height: 400px;
  }
}
</style>